import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from "class-validator";

export class PickUpDTO{

    @ApiProperty()
    @IsNotEmpty({message: 'Pickup Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    pickUpId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Pickup should not be empty'})
    pickUp: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    // @ApiProperty()
    // route: string;
}